import { render } from "./questioneditorgnum.vue?vue&type=template&id=171b1802&scoped=true"
import script from "./questioneditorgnum.vue?vue&type=script&lang=js"
export * from "./questioneditorgnum.vue?vue&type=script&lang=js"

import "./questioneditorgnum.vue?vue&type=style&index=0&id=171b1802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b1802"]])

export default __exports__